<template>
  <div id="app">
    <div class="appContainer">
      <div id="messages" class="messagesContainer">
        <div class="message" v-for="message in messages">
          <p class="message__text">{{message.text}}</p>
          <p class="message__sender">{{message.sender.email}}</p>
        </div>
      </div>

      <form @submit.prevent="send" class="messageForm">
        <p class="typing">typing: <span v-if="user.email != typer" v-for="typer in typing">{{typer}}</span></p>
        <input @keyup="typingIndicator" v-model="newMessage" type="text" placeholder="message">


      </form>
    </div>

  </div>
</template>

<script>
  import firebase from 'firebase'
  import 'minireset.css/minireset.css'
  import '@/assets/global.scss';

  export default {
    name: 'app',
    data() {
      return {
        messages: null,
        typing: null,
        user: null,
        newMessage: ''
      }
    },
    mounted() {
      //create a reference to google auth to use later
      const googleAuth = new firebase.auth.GoogleAuthProvider();
      //This checks whether or not someone is signed in
      const user = firebase.auth().currentUser;
      if (user) {
        // User is signed in.
        //update user object in vue
        this.user = user
        firebase.database().ref('messages/').on('value', (snap) => {
          this.messages = snap.val()
          setTimeout(() => {
            let messagesDiv = document.getElementById("messages");
            messagesDiv.scrollTop = messagesDiv.scrollHeight;
          }, 100)

        })
        firebase.database().ref('typing/').on('value', (snap) => {
          this.typing = snap.val()
        })
      } else {
        // No user is signed in.
        //login with google
        firebase.auth().signInWithRedirect(googleAuth);

      }

    },
    methods: {
      send() {
        firebase.database().ref('messages').push().set({
          text: this.newMessage,
          sender: {
            email: this.user.email,
            uid: this.user.uid
          }
        }, (e) => {
          this.newMessage = ''
          firebase.database().ref('typing/' + this.user.uid).set(null)
        })
      },
      typingIndicator() {
        if (this.newMessage) {
          firebase.database().ref('typing/' + this.user.uid).set(this.user.email)
        } else {
          firebase.database().ref('typing/' + this.user.uid).set(null)
        }

      }

    }
  }
</script>
